import React from 'react';

import amplitude from 'amplitude-js';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { getRecipientTypeParam, transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import { DELIVERY_METHOD_SELECTED, FEE_INFO_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    PAYMENT_COUNTRY,
    PAYMENT_FLOW,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    RECIPIENT_TYPE,
    SCREEN,
    TRANSFER_COUNT,
} from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { COUNTRY_AND_METHOD, NEW } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { DELIVERY_BANK_CARD, DELIVERY_SWIFT } from 'apps/auth/constants/Constants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import { PanelButton } from '../components/PanelButton/PanelButton';
// import FeeTextPopup from '../send/popups/FeeTextPopup';

const GlobalSources = (props) => {
    const { globalSources, sendFlowV3, userCountry, toCurrency, toCountry } = useExtra();
    const { globalSwiftSubtitle, globalCardSubtitle, globalCardCategory, globalSwiftCategory } = usePageMessages();

    const getIcon = (sourceId) => (sourceId === 1001 ? 'globe' : 'card');

    const getSubtitle = (sourceId) => (sourceId === 1001 ? globalSwiftSubtitle : globalCardSubtitle);

    const getHref = (sourceId) => {
        const path = sourceId === 1001 ? DELIVERY_SWIFT : DELIVERY_BANK_CARD;
        return `${props.sendGlobalUrIPrefix}/${path}/send${props.sendUriPostfix || ''}`;
    };
    const transferCount = __isBrowser__ ? localStorage.getItem('transferCount') : null;

    const sendAmplitudeEvent = (id) => {
        amplitude.getInstance().logEvent(DELIVERY_METHOD_SELECTED, {
            [PAYOUT_METHOD]: id === 1001 ? transactionMethods.GLOBAL_SWIFT : transactionMethods.GLOBAL_CARD,
            [PAYMENT_FLOW]: NEW,
            [RECIPIENT_TYPE]: getRecipientTypeParam(props.recipientType),
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_CURRENCY]: toCurrency?.code,
            [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
        });
    };

    const getSubheaderText = (id) => {
        if (id === 1001) {
            return globalSwiftCategory;
        } else if (id === 1002) {
            return globalCardCategory;
        }
        return null;
    };

    // const openPopup = (text) => {
    //     props.popupRef.current?.open(<FeeTextPopup text={text} isShowTerms={false} popupRef={props.popupRef} />);
    // };

    if (Array.isArray(globalSources) && globalSources.length > 0) {
        return (
            <Row indent={!sendFlowV3 ? 'adaptive-32-48' : null}>
                {globalSources
                    .filter((sf) => sf !== null && sf !== undefined)
                    .map((s) => (
                        <div key={s.code}>
                            {sendFlowV3 && (
                                <Separator
                                    isSubheader
                                    marginBottom="16px"
                                    marginTop="16px"
                                    leftText={getSubheaderText(s.id)}
                                    // rightText={'Add text'}
                                    onClick={() => {
                                        // openPopup('Add text');
                                        amplitude.getInstance().logEvent(FEE_INFO_CLICKED, {
                                            [SCREEN]: COUNTRY_AND_METHOD,
                                            [PAYOUT_METHOD]: s.id === 1001 ? transactionMethods.GLOBAL_SWIFT : transactionMethods.GLOBAL_CARD,
                                            [PAYMENT_COUNTRY]: userCountry?.nameEn,
                                        });
                                    }}
                                />
                            )}
                            <PanelButton
                                to={getHref(s.id)}
                                onClick={() => sendAmplitudeEvent(s.id)}
                                icon={getIcon(s.id)}
                                mainText={s.name}
                                secondaryText={getSubtitle(s.id)}
                            />
                        </div>
                    ))}
            </Row>
        );
    } else {
        return false;
    }
};
export default GlobalSources;
